import { cn } from "@/lib/utils";
import Image from '@/components/ui/Image';
import Link from 'next/link';
import { sectionVariants } from "@/types";
import { actionBackgroundColors } from "@/lib/utils";

interface StayConnectProps {
  darkMode?: boolean;
  variant?: sectionVariants;
  stayConnected?: {
    title?: string;
    subtitle?: string;
    showLinkedIn?: boolean;
    linkedInLink?: string;
  };
}

export const StayConnect = ({ stayConnected, darkMode = false, variant = "A" }: StayConnectProps) => {
 
  return (
    <div className="container pt-6 md:pt-14 pb-10 md:pb-14 text-foreground">
      <div className="flex flex-col md:flex-row gap-10 reserve:hidden!">
        <div className="flex flex-col gap-4 text-center md:text-left">
          <h3>{stayConnected?.title ?? "Stay Connected"}</h3>
          <p className="paragraph-base">{stayConnected?.subtitle ?? "Follow us on LinkedIn for the latest market insights, trends, and valuable resources."}</p>
        </div>
        {stayConnected?.showLinkedIn && (
          <div className="flex items-center justify-end flex-1">
            <Link 
              href={stayConnected?.linkedInLink ?? "/"} 
              tabIndex={-1}
              className={cn(
                "flex flex-1 lg:flex-none justify-center items-center gap-3 px-8 py-4 rounded-md text-primary",
                actionBackgroundColors(darkMode, variant),
              )}
            >   
              <Image src="/icon-linkedin-color.svg" alt="LinkedIn" width={24} height={24} /> 
              <span className="whitespace-nowrap">Follow us on LinkedIn</span>
            </Link>
          </div>
        )}
      </div>

      <div className="hidden flex-col md:flex-row gap-10 reserve:flex!">
        <div className="flex flex-col gap-4 text-center md:text-left">
          <h3>Octet Reserve</h3>
          <p className="paragraph-base">A private financial membership.</p>
        </div>
        {stayConnected?.showLinkedIn && (
          <div className="flex items-center justify-end flex-1">
            <Link 
              href={stayConnected?.linkedInLink ?? "/"} 
              tabIndex={-1}
              className={cn(
                "flex flex-1 lg:flex-none justify-center items-center gap-3 px-8 py-4 rounded-md text-primary",
              )}
            >   
              <Image src="/icon-linkedin-color-reserve.svg" alt="LinkedIn" width={24} height={24} /> 
              <span className="whitespace-nowrap font-light">Follow us on LinkedIn</span>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};
